import React from "react"
import { useState } from 'react'

const styles = {
    btn: {
        background: '#2196f3',
        margin: '5px',
        padding: '5px',
        borderRadius: '10px',
        color: 'white'
    },
    input: {
        width: '308px',
    }
}

export default function AddUser({newId, mejTodos}) {
    const [person, setPerson] = useState({
        id: newId, 
        complited: false, 
        description: "The Hulk is the alter ego of Dr. Robert Bruce Banner. Banner is a scientist who, as a result of exposure to gamma radiation becomes a large, superhumanly strong, (usually) green creature of pure rage whenever he becomes angry. Although the Hulk is usually classified as a superhero, he and Banner share a Dr. Jekyll and Mr. Hyde-like relationship. In his most common incarnation, the Hulk has little intelligence and self-control and can cause great destruction, although he also is inclined to fight evil and protect the innocent. Because of the Hulk's awesome rage and destructive capability, he is regulary hunted by the military and other superheroes.", 
        title: "Hesam", 
        imageUrl:"http://lions-narbonne-doyen.fr/wp-content/uploads/2022/01/hs.jpg"
    });
   
      function handleNameChange(e) {
        setPerson({
          ...person,
          title: e.target.value
        });
      }

      function handleDescriptionChange(e) {
        setPerson({
          ...person,
          description: e.target.value
        });
      }

      function handleImageChange(e) {
        setPerson({
          ...person,
          imageUrl: e.target.value
        });
      }

return(
    <div>
      <h3>Ajouter un nouveau super-Héros à l'équipe</h3>
        <div>
        <label>
            Name:
            <input
            value={person.title}
            onChange={handleNameChange}
            />
        </label>
        </div>
        <div>

      <label>
            Description:
            <textarea
            value={person.description}
            onChange={handleDescriptionChange}
            />
        </label>
        </div>
        <div>
      <label>
        Image:
        <input
          value={person.imageUrl}
          onChange={handleImageChange}
        />
      </label>
      </div>
      
      {/* <p>
        {person.id}{' '}
        {person.title}{' '}
        {person.description}{' '}
        ({person.imageUrl})
      </p> */}

      <button style={styles.btn}  onClick={() => {
       console.log(person)
       mejTodos(person)
      }}>Add new Superhero</button>
    </div>
)}